import { render, staticRenderFns } from "./main-auctions-banner.vue?vue&type=template&id=9489d83a&scoped=true"
import script from "./main-auctions-banner.vue?vue&type=script&lang=js"
export * from "./main-auctions-banner.vue?vue&type=script&lang=js"
import style0 from "./main-auctions-banner.vue?vue&type=style&index=0&id=9489d83a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9489d83a",
  null
  
)

export default component.exports